import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const EmptyStateContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  justify-content: center;
  margin: 100px 0;
  width: 100%;

  h6,
  p {
    color: ${colours.neutral[700]};
  }
`;

export const EmptyStateIcon = styled('img')`
  width: 220px;
`;
